import { BaseDataProvider } from '../../../core/BaseDataProvider';
import RouterHelper from '../../../core/RouterHelper';
import { buildNavAccess } from './permsChecker';
import { PLATFORM, PLATFORM_THEME, PLATFORM_LABELS, DISABLED_PLATFORMS } from './platforms/platformConstants';
import { getProviderForPlatform } from './providerRegistry';
import { AERO_REDIRECT_URL } from './platforms/aero/NavigationURLs';

const provider = new BaseDataProvider();
export { PLATFORM, PLATFORM_THEME, PLATFORM_LABELS, DISABLED_PLATFORMS };

export const getPlatformTheme = (platformId) => {
	return PLATFORM_THEME[platformId] || PLATFORM_THEME[PLATFORM.ACTIVATE];
};

export const getNavConfigForPlatform = (platformId) => {
	const platformProvider = getProviderForPlatform(platformId);
	if (platformProvider) return platformProvider.getNavConfig();
	return { sections: [] };
};

export const getIconMapForPlatform = (platformId) => {
	const platformProvider = getProviderForPlatform(platformId);
	return platformProvider ? platformProvider.getIconMap() : {};
};

export const getMenuBottomForPlatform = (platformId) => {
	const platformProvider = getProviderForPlatform(platformId);
	return platformProvider ? platformProvider.getMenuBottom() : null;
};

export const getFilteredNavForPlatform = ({ platformId, perms = {}, authUser = {} }) => {
	const navConfig = getNavConfigForPlatform(platformId);
	return buildNavAccess({ navConfig, perms, authUser });
};

export const fetchReferralToken = (tokenType) => {
	return provider.get(`/api/v1/referral_token/?token_type=${tokenType}`);
};

export const loginWithReferralToken = (referralToken, referralTokenType = "view_iq") => {
	return provider.post("/api/v1/auth/", { referral_token: referralToken, referral_token_type: referralTokenType }, false);
};

export const openExternalWithReferralToken = async (tokenType, externalLink) => {
	try {
		const tokenData = await fetchReferralToken(tokenType);
		const referralToken = tokenData?.referral_token || tokenData?.referralToken;
		const serverReferralUrl = tokenData?.referral_url || tokenData?.referralUrl;
		let targetUrl = serverReferralUrl || externalLink;
		if (!serverReferralUrl && externalLink && referralToken) {
			const separator = externalLink.includes('?') ? '&' : '?';
			targetUrl = `${externalLink}${separator}referral_token=${encodeURIComponent(referralToken)}&referral_token_type=${encodeURIComponent(tokenType)}`;
		}
		if (targetUrl) RouterHelper.goToExternal(targetUrl);
	} catch (_xhrError) {
		// Swallow: failed token fetch shouldn't break nav. Original link not opened to avoid unauth'd landing.
	}
};

export const switchPlatform = ({ targetPlatform, currentPlatform }) => {
	if (targetPlatform === currentPlatform) return Promise.resolve();

	if (DISABLED_PLATFORMS.includes(targetPlatform)) {
		return Promise.resolve();
	}

	if (targetPlatform === PLATFORM.AERO) {
		window.location.assign(AERO_REDIRECT_URL);
		return Promise.resolve();
	}

	return fetchReferralToken(targetPlatform)
		.then((data) => {
			window.location.assign(data.referral_url);
		});
};
